import { JsonQuery } from '../../../../packages/JsonQuery';
import { TGeoValue } from '../../../../packages/api-models/common/json_query';
import { TThunkAction } from '../../types/redux';
import { changeJsonQuery, fetchTags } from '../filters';

/** Deprecated. Use changeJsonQuery */
export function addGeo(value: TGeoValue): TThunkAction {
  return (dispatch, getState) => {
    const {
      filters: { jsonQuery },
    } = getState();

    const jq = new JsonQuery(jsonQuery);
    jq.selectGeo(value);

    dispatch(
      changeJsonQuery({
        appliedModifiers: [{ action: 'selectGeo', arguments: [value] }],
        prevJsonQuery: jsonQuery,
        nextJsonQuery: jq.toJSON(),
      }),
    );
    dispatch(fetchTags());
  };
}
